import { yupResolver } from '@hookform/resolvers';
import * as Yup from 'yup';

export const EMAIL = 'email';

export const schema = Yup.object().shape({
  [EMAIL]: Yup.string().required('Обязательное поле').email('Неверный формат электронной почты'),
});

export const formScheme = {
  initialScheme: {
    mode: 'onSubmit',
    reValidateMode: 'onChange',
    resolver: yupResolver(schema),
    defaultValues: {
      ...schema.cast(),
      [EMAIL]: '',
    },
  },
};
